import { Box, Stack, Typography } from '@mui/material'
import { downloadCertificate } from 'api/certificates'
import LoadingPlaceholder from 'components/placeholders/LoadingPlaceholder'
import { UICertificateIcon, UIDownloadIcon } from 'features/UI'
import moment from 'moment'
import { useState } from 'react'
import { useMutation } from 'react-query'
import { Certificate } from 'types'
import { downloadArrayBuffer } from 'utils/common'

export const CertificateItem = ({ certificate }: { certificate: Certificate }) => {
  const [isLoading, setIsLoading] = useState(false)
  const download = useMutation(downloadCertificate)

  const handleDownload = async () => {
    try {
      setIsLoading(true)
      const response = await download.mutateAsync({
        id: certificate.id,
        type: certificate.type,
        timezone: moment().format('Z'),
      })
      downloadArrayBuffer(response)
    } catch (e) {
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Stack
      display="flex"
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      spacing={1}
      p={1}
      borderRadius={2}
      sx={{ background: 'white' }}
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        <Box p={1} display="flex" justifyContent="center" alignItems="center">
          <UICertificateIcon />
        </Box>
        <Stack direction="column" alignItems="flex-start" spacing={0.25}>
          <Typography variant="body1" fontWeight="bold" textAlign="left">
            {certificate.name}
          </Typography>

          <div>Passed {moment(certificate.createdAt).format('MM/DD/YY')}</div>
        </Stack>
      </Stack>

      <Box
        p={1}
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{ cursor: 'pointer' }}
      >
        {isLoading && <LoadingPlaceholder />}
        {!isLoading && <UIDownloadIcon onClick={handleDownload} />}
      </Box>
    </Stack>
  )
}
